import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import { TProdutosArquivoBula } from "../DialogVisualizarReceituario";
import PaperDraggable from "../../../../../../../../components/PaperDraggable";
import useImprimirArquivo from "../../../../../../../../lib/useImprimirArquivo";
import DisplayNotFoundInfo from "../../../../../../../../components/DisplayNotFindInfo";
import { useState } from "react";

export default function DialogVisualziarBulas({
    open,
    bulas,
    handleClose
}: DialogVisualziarBulasProps) {

    const imprimirArquivo = useImprimirArquivo();

    const [bulaSelecionada, setBulaSelecionada] = useState<number | null>(null);

    const handleImprimirBula = () => {
        if (bulaSelecionada) {
            imprimirArquivo(`imprimir-arquivo/${bulaSelecionada}`)
        }
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xs"
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            fullWidth
        >
            <DialogTitle
                style={{ cursor: 'move' }}
                id="draggable-dialog-title"
            >
                <Typography variant="h6" component="div">
                    Visualizar Bulas
                </Typography>
            </DialogTitle>
            <DialogContent>
                {bulas && bulas.length > 0 ? (
                    <Box sx={{ mt: 2 }}>
                        <Stack spacing={3}>
                            <FormControl fullWidth>
                                <InputLabel id="select-bula-label">Selecione a bula</InputLabel>
                                <Select
                                    labelId="select-bula-label"
                                    id="select-bula"
                                    value={bulaSelecionada}
                                    label="Selecione a bula"
                                    onChange={(e) => setBulaSelecionada(e.target.value as number)}
                                >
                                    {bulas.map((bula, index) => (
                                        <MenuItem
                                            key={index}
                                            value={bula.arquivo_id}
                                            disabled={!bula.arquivo_id || bula.arquivo_id <= 0}
                                        >
                                            {bula.produto_nome}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Button
                                    variant="contained"
                                    onClick={handleImprimirBula}
                                    disabled={!bulaSelecionada}
                                    sx={{ minWidth: 150 }}
                                >
                                    Visualizar Bula
                                </Button>
                            </Box>
                        </Stack>
                    </Box>
                ) : (
                    <DisplayNotFoundInfo label="Nenhuma bula encontrada" />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogVisualziarBulasProps {
    open: boolean;
    bulas: TProdutosArquivoBula
    handleClose: () => void;
}